<!-- @if (!submitted()) {
    <div class="wizard">
        <div class="steps">
            <div class="dot" [class.active]="step()===1" (click)="chooseStep(1)">1</div>
            <div class="line" [class.active]="step()>=2" [style.--i]="(1 - previousStep()) * .34 + 's'" [style.--y]="(previousStep() - 1) * .34 + 's'"></div>
            <div class="dot" [class.active]="step()===2" (click)="chooseStep(2)">2</div>
            <div class="line" [class.active]="step()>=3" [style.--i]="(2 - previousStep()) * .34 + 's'" [style.--y]="(previousStep() - 2) * .34 + 's'"></div>
            <div class="dot" [class.active]="step()===3" (click)="chooseStep(3)">3</div>
            <div class="line" [class.active]="step()>=4" [style.--i]="(3 - previousStep()) * .34 + 's'" [style.--y]="(previousStep() - 3) * .34 + 's'"></div>
            <div class="dot" [class.active]="step()===4" (click)="chooseStep(4)">4</div>
            <div class="line" [class.active]="step()>=5" [style.--i]="(4 - previousStep()) * .34 + 's'" [style.--y]="(previousStep() - 4) * .34 + 's'"></div>
            <div class="dot" [class.active]="step()===5" (click)="chooseStep(5)">5</div>
        </div>

        @switch (step()) {
            @case (1) {
                <form
                    class="form step-1"
                    [formGroup]="form"
                    autocomplete="on">
                    <div
                        class="form-group dropzone"
                        [class.dragover]="isDragOver()"
                        [class.preview]="!!currentPreviewUrl()"
                        (dragleave)="onDragLeave()"
                        (dragover)="onDragOver($event)"
                        (drop)="onFileDrop($event)">

                        @if (!currentPreviewUrl()) {
                            <label class="upload-label">
                                Upload a photo of your drawing, artwork, or handwritten message
                            </label>

                            <button
                                class="button submit-btn primary"
                                (click)="fileInput.click()"
                                type="button">
                                Choose a file
                            </button>

                            <button
                                id="scan-button"
                                #scanButtonRef
                                class="button outline"
                                [disabled]="isLoading() || gsLoading()"
                                (click)="scanWithGeniusScan()"
                                type="button">
                                @if (gsLoading()) { Scanning… } @else { Scan with a camera }
                            </button>
                        }

                        <div
                            class="dropzone-content"
                            [class.dropzone-content--additional-margin]="
                                naturalH() > naturalW() && rotated()
                            "
                            [class.dropzone-content--rotated]="rotated()"
                            [style.aspectRatio]="rotated() ? '1 / 1' : null"
                            [style.--i]="computeQuadraticMargin(naturalH() - naturalW()) + 'px'">

                            @if (!currentPreviewUrl()) {
                                <p>📁 Click to choose a file or drag here</p>
                                <small>Accepts image, .pdf, .doc, .docx – Max 50 MB</small>
                            } @else {
                                <div class="clear-file" (click)="removeCurrentFile($event)">✖</div>
                                <img
                                    class="preview-img"
                                    [style.transform]="'rotate(' + rotationForActive() + 'deg)'"
                                    [src]="currentPreviewUrl()!"
                                    (load)="onImgLoad($event)"
                                    alt="preview" />
                            }
                        </div>

                        <input
                            hidden
                            (change)="onFileChange($event)"
                            #fileInput
                            accept="image/png, image/gif, image/jpeg"
                            type="file"
                            [multiple]="isMultipleUpload" />
                    </div>

                    @if (currentPreviewUrl()) {
                        <div class="rotate-tools">
                            <button class="btn" (click)="rotateLeft()" type="button">
                                <span class="material-symbols-outlined md">rotate_left</span>
                            </button>
                            Rotate
                            <button class="btn" (click)="rotateRight()" type="button">
                                <span class="material-symbols-outlined md">rotate_right</span>
                            </button>
                        </div>
                    }

                    @if (isMultipleUpload && previewUrls().length > 1) {
                        <div class="gallery">
                            @for (thumb of previewUrls(); track $index) {
                                <button
                                    type="button"
                                    class="thumb"
                                    [class.active]="activeIndex() === $index"
                                    (click)="setActiveIndex($index)">
                                    <img [src]="thumb" [alt]="'image ' + ($index + 1)" />
                                    <span class="badge">{{$index + 1}}</span>
                                </button>
                            }
                        </div>

                        <div class="multi-meta">
                            <span>{{ previewUrls().length }} files selected</span>
                            <button type="button" class="link danger" (click)="clearAllFiles()">Clear all</button>
                        </div>
                    }
                </form>

                @if (currentPreviewUrl()) {
                    <div class="nav">
                        <button
                            class="button submit-btn ghost"
                            (click)="removeCurrentFile($event)"
                            type="button">
                            ← Back
                        </button>
                        <button
                            class="button submit-btn primary"
                            [disabled]="files().length === 0"
                            (click)="goNext()"
                            type="button">
                            Next →
                        </button>
                    </div>
                }

                @if (!currentPreviewUrl()) {
                    <h4>Other ways to upload:</h4>
                    <div class="wrap-buttons">
                        <a href="https://play.google.com/store/apps/details?id=com.fwollo.wondrdrop" target="_blank">
                            <img src="assets/img/google.webp" alt="Google">
                        </a>
                        <a href="https://apps.apple.com/us/app/wondrvoices-share-kindness/id6748359471 ">
                            <img src="assets/img/app-store.webp" alt="App Store">
                        </a>
                    </div>
                }
            }

            @case (2) {
                <form class="form" [formGroup]="form">
                    <section class="tags-section">
                        <div class="section-title">
                            <h3>Tags</h3>
                            <span class="counter">{{ totalSelectedTags }}/3</span>
                        </div>
                    
                        <div class="chips">
                            @for (opt of mergedTags; track opt.key) {
                                <button
                                    class="chip"
                                    [class.active]="isMergedSelected(opt)"
                                    [disabled]="isMergedDisabled(opt)"
                                    (click)="toggleMerged(opt)"
                                    type="button">
                                    <span class="emoji">{{ opt.emoji }}</span>
                                    {{ opt.label }}
                                </button>
                            }
                            <button
                                class="chip"
                                style="border:1px solid orangered"
                                #refCustomMerged
                                (click)="refCustomMerged.style.display='none'"
                                type="button">
                                <span class="emoji">➕</span>
                            </button>
                        </div>
                    
                        @if (refCustomMerged.style.display === 'none') {
                            <div class="add-own">
                                <input
                                    class="own-input"
                                    type="text"
                                    [value]="draftUnified"
                                    (input)="draftUnified = ($any($event.target).value || '').slice(0, 24)"
                                    (keydown.enter)="addCustomUnified('what')"
                                    placeholder="Add your own" />
                                <div style="display:flex; gap:8px;">
                                    <button
                                        class="btn add"
                                        type="button"
                                        (click)="addCustomUnified('what')"
                                        [disabled]="!canAddDraftUnified('what')">
                                        Add
                                    </button>
                                </div>
                            </div>
                        }
                    
                        <small class="hint">Pick up to 3 in total.</small>
                    </section>
                    
                </form>
                <div class="nav">
                    <button
                        class="button submit-btn ghost"
                        (click)="goBack()"
                        type="button">
                        ← Back
                    </button>
                    <button
                        class="button submit-btn primary"
                        (click)="goNext()"
                        type="button">
                        Next →
                    </button>
                </div>
            }

            @case (3) {
                <form class="form" [formGroup]="form">
                    <div class="form-group">
                        <div class="section-title">
                            <h3>Add Note <span class="optional">(optional)</span></h3>
                        </div>
                    
                        <div class="input-wrapper textarea">
                            <textarea
                                formControlName="note"
                                placeholder=" "
                                rows="3"
                                style="min-height: 96px"
                                aria-required="false"
                                (input)="autoResize($event)"></textarea>
                            <label [class.focused]="form.get('note')?.value">Describe in more detail (optional)</label>
                        </div>
                    </div>
                    
                </form>
                <div class="nav">
                    <button type="button" class="button submit-btn ghost" (click)="goBack()">← Back</button>
                    <button type="button" class="button submit-btn primary" (click)="goNext()">Next →</button>
                </div>
            }

            @case (4) {
                <form
                    class="form"
                    [formGroup]="form"
                    (ngSubmit)="submit()"
                    autocomplete="on">
                    <section class="info-block public">
                        <div class="block-head">
                            <span class="ico">📣</span>
                            <div class="t">
                                <h4>Publicly shown on card</h4>
                            </div>
                        </div>

                        <div
                            class="form-group"
                            >
                            <div class="input-wrapper with-counter">
                                <input
                                    [attr.maxlength]="maxMap.location"
                                    autocomplete="off"
                                    formControlName="location"
                                    name="loc"
                                    placeholder=" "
                                    aria-autocomplete="list"
                                    aria-haspopup="listbox"
                                    #refLocation 
                                    [readOnly]="locationSelected()"
                                    [disabled]="locationSelected()">
                                <label [class.focused]="form.get('location')?.value">Where is this card coming from *</label>

                                @if (locationSelected()) {
                                    <span 
                                        class="location-close"
                                        (click)="
                                            form.get('location')?.setValue(''); 
                                            locationSelected.set(false);
                                            form.get('creditTo')?.setValue(''); 
                                        ">
                                        <span class="material-symbols-outlined md">close</span>
                                    </span>
                                }
                            </div>
                        </div>
                        
                        <div
                            class="form-group"
                            [class.custom-credit-to-field]="locationSelected()"
                            [class.custom-credit-to-field-hide]="!locationSelected()">
                            <div class="input-wrapper with-counter">
                                <w-autocomplete
                                    placeholder="Enter your custom credit to *"
                                    emptyHint="Type to search"
                                    [formControlName]="'customCreditTo'"
                                    [class.short-autocomplete]="true"
                                    (select)="applyTextFilter($event)"
                                    (inputChange)="onCustomCreditToChange($event)" />
                            </div>  
                        </div>
                    </section>
                </form>
                <div class="nav">
                    <button
                        class="button submit-btn ghost"
                        (click)="goBack()"
                        type="button">
                        ← Back
                    </button>
                    <button
                        class="button submit-btn primary"
                        [disabled]="
                            !form.get('lat')?.value || 
                            !form.get('lng')?.value || 
                            !form.get('creditTo')?.value
                        "
                        (click)="goNext()"
                        type="button">
                        Next →
                    </button>
                </div>
            }

            @case (5) {
                <form
                    class="form"
                    [formGroup]="form"
                    (ngSubmit)="submit()"
                    autocomplete="on">
                    <section class="info-block private">
                        <div class="block-head">
                            <span class="ico">🔒</span>
                            <div class="t">
                                <h4>Never shown on card</h4>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="input-wrapper with-counter">
                                <input formControlName="name" placeholder=" " [attr.maxlength]="maxMap.name" autocomplete="name" autocapitalize="words" name="name" />
                                <label [class.focused]="form.get('name')?.value">Name</label>
                                <span class="counter">{{ getLen('name') }}/{{ maxMap.name }}</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="input-wrapper with-counter">
                                <input [attr.maxlength]="maxMap.email" name="email" autocomplete="email" formControlName="email" inputmode="email" placeholder=" " spellcheck="false" type="email" />
                                <label [class.focused]="form.get('email')?.value">Email</label>
                                <span class="counter">{{ getLen('email') }}/{{ maxMap.email }}</span>
                            </div>
                        </div>
                    </section>
                </form>
                <div class="nav">
                    <button type="button" class="button submit-btn ghost" (click)="goBack()">← Back</button>
                    @if (!isLoading()) {
                        <button [disabled]="form.invalid && form.touched && form.dirty" class="button submit-btn primary" type="submit" (click)="submit()">Submit</button>
                    } @else {
                        <button class="button submit-btn primary" disabled>
                            <span class="loader"></span>
                        </button>
                    }
                </div>
            }
        }

        @if (devProgressVisible()) {
            <div class="dev-panel" role="status" aria-live="polite">
                <div class="dev-panel__head">
                    <strong>Dev Upload Queue</strong>
                    <span class="dev-panel__count">
                        {{ perItemStatusDoneLength() }}/{{ perItemStatus().length }} done
                    </span>
                </div>
        
                <div class="dev-progress">
                    <div class="dev-progress__bar" [style.width.%]="progressPercent()"></div>
                </div>
                <div class="dev-progress__meta">
                    <span>{{ progressMessage() || 'Preparing…' }}</span>
                    <span>{{ progressPercent() }}%</span>
                </div>
        
                <ul class="dev-list">
                    @for (status of perItemStatus(); track $index) {
                        <li class="dev-item">
                            <span class="dev-item__idx">#{{ $index + 1 }}</span>
        
                            <span
                                class="dev-item__name"
                                [title]="">
                                {{ getFileName($index) }}
                            </span>
        
                            <span
                                class="dev-item__stage"
                                [class.is-queued]="status === 'pending'"
                                [class.is-uploading]="status === 'uploading'"
                                [class.is-uploaded]="status === 'uploaded'"
                                [class.is-creating]="status === 'creating'"
                                [class.is-done]="status === 'done'"
                                [class.is-error]="status === 'failed'">
                                {{ statusIcon(status) }} {{ status }}
                            </span>
                        </li>
                    }
                </ul>
            </div>
        }
        
        
    </div>
} @else {
    <div class="submit-another-wrap">
        <h3>Thank you for your submission!</h3>
        <p>Your voice is now part of a growing community that spreads kindness and hope. We’ll be in touch soon.</p>
        <button
            class="button submit primary"
            (click)="submitted.set(false); resetAll(); step.set(1);">
            Submit Another →
        </button>
    </div>
} -->


<div class="submit-cards-blocked">
    <h1>Submit cards from our mobile app</h1>

    <p>
        For now, submitting new cards is only available in the WondrVoices mobile app.  
        The app gives you a smoother experience to scan, crop, and upload your drawings
        or handwritten messages in just a few taps.
    </p>

    <p>
        Download the app and tap
        <strong>“Submit a card”</strong> to share your voice.
    </p>

    <div class="submit-cards-blocked__stores wrap-buttons">
        <a
            href="https://play.google.com/store/apps/details?id=com.fwollo.wondrdrop"
            target="_blank"
            rel="noopener noreferrer">
            <img src="assets/img/google.webp" alt="Get it on Google Play">
        </a>
        <a
            href="https://apps.apple.com/us/app/wondrvoices-share-kindness/id6748359471"
            target="_blank"
            rel="noopener noreferrer">
            <img src="assets/img/app-store.webp" alt="Download on the App Store">
        </a>
    </div>

    <p class="submit-cards-blocked__hint">
        Already submitted a card from the app?
        Your voice will appear on the map once it is reviewed.
    </p>
</div>

<div class="preload" aria-hidden="true" style="position: absolute; width: 0; height: 0; overflow: hidden;">
    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">rotate_right</span>
    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">rotate_left</span>
    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">location_on</span>
</div>
